module.exports = __webpack_public_path__ + "img/teams.f2908dc2.svg";